import { type RootState } from "@/store";

export const getPlanTypeFromStore = (state: RootState) => state.planType;
export const getCurrentPlanType = (state: RootState) => state.planType;
export const getPendingUpgrade = (state: RootState) => state.pendingUpgrade;
export const getCheckoutSource = (state: RootState) => state.checkoutSource;
// computed/Derived selectors
export const isUpgradeFlow = (state: RootState) =>
  Boolean(state.planType.pendingUpgrade);
export const isNewPurchaseFlow = (state: RootState) =>
  state.planType.checkoutSource === "verifyToken";
export const hasActiveCheckout = (state: RootState) =>
  Boolean(state.planType.checkoutSource);
export const getTargetPlanType = (state: RootState) =>
  state.planType.pendingUpgrade || state.planType.planType || "studentPlan";
export const isStudentPlan = (state: RootState) =>
  state.planType.planType === "studentPlan";
export const isTeacherPlan = (state: RootState) =>
  state.planType.planType === "teacherPlan";
export const canUpgradeToTeacher = (state: RootState) =>
  state.planType.planType === "studentPlan";
